var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('button',{staticClass:"btn",on:{"click":_vm.clk}},[_vm._v("测试获取")])])}
var staticRenderFns = []

export { render, staticRenderFns }